import { css } from '@compiled/react';
import { useUniformCurrentComposition } from '@uniformdev/canvas-react';

import { media } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags as featureFlagsManifest } from '@/utils/feature-flags/feature-flag-manifest';
import { useScrollTracking } from '@/utils/scroll-tracking/scroll-tracking';

import UniformHeroIntro from '../../hero-intro/src/hero-intro';

import UniformCustomerStoriesDetailsHeroQuote from './customer-stories-details-hero-quote';

type Nullable<T> = T | null;

export interface UniformCustomerStoriesDetailsHeroProps {
	title?: Nullable<string>;
	subtitle?: Nullable<string>;
	imgSrc?: Nullable<string>;
	imgAlt?: Nullable<string>;
	quote?: Nullable<string>;
	author?: Nullable<string>;
	role?: Nullable<string>;
	company?: Nullable<string>;
}

const heroContainerCss = css({
	display: 'grid',
	justifyContent: 'space-between',
	marginBlockStart: token('space.400'),
	maxWidth: '100%',
	boxSizing: 'border-box',
	gap: '24px',
	width: '100%',
	gridTemplateColumns: 'minmax(0, 1fr)',
	[media.above.md]: {
		gap: '32px',
	},
});

export const UniformCustomerStoriesDetailsHero = ({
	title,
	subtitle,
	imgSrc,
	imgAlt,
	quote,
	author,
	role,
	company,
}: UniformCustomerStoriesDetailsHeroProps) => {
	const composition = useUniformCurrentComposition();
	const compositionId = composition?.data?._id;
	const tracker = useScrollTracking('UniformCustomerStoriesDetailsHero', {
		dwellTimeEnabled: true,
		additionalAttributes: {
			compositionId,
		},
	});
	return (
		<div
			ref={
				checkFeatureFlagGate(featureFlagsManifest.gwp7603UniformPageDwellTime) ? tracker?.ref : null
			}
			css={heroContainerCss}
		>
			<UniformHeroIntro title={title} subtitle={subtitle} alignment={imgSrc ? 'left' : 'center'} />
			{quote && (
				<UniformCustomerStoriesDetailsHeroQuote
					imgSrc={imgSrc}
					imgAlt={imgAlt}
					quote={quote}
					author={author}
					role={role}
					company={company}
				/>
			)}
		</div>
	);
};

export default UniformCustomerStoriesDetailsHero;
